import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormGroupDirective } from '@angular/forms';
import { emailValidator, matchingPasswords, checkAccountExist } from 'src/app/theme/utils/app-validators';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { PhonePipe } from 'src/app/theme/pipes/phone.pipe';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {
  infoForm: FormGroup;  
  passwordForm: FormGroup;
  userDetails = null;
  saveButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Save',
    buttonColor: 'primary',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  }
  changeButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Change',
    buttonColor: 'primary',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  }
  constructor(
    public formBuilder: FormBuilder, 
    private apiService: ApiService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private subscription: SubscriptionService,
    private phonePipe: PhonePipe
  ) { }

  ngOnInit() {
    let resolverUserDetails = this.route.snapshot.data.userDetails;
    if(resolverUserDetails['response']['status'] === 1) {
      this.userDetails = resolverUserDetails['response']['data']['users'];
    }
    this.infoForm = this.formBuilder.group({
      'first_name': ['', Validators.compose([Validators.required, Validators.maxLength(35)])],
      'last_name': ['', Validators.compose([Validators.required, Validators.maxLength(35)])],
      'email_id': ['', {
          validators: [Validators.required, emailValidator],
          // asyncValidators: [checkAccountExist(this.apiService, this.userDetails, 'email_id')],
          // updateOn: 'blur'
        }],
      'company': [''],
      'phone_number': ['', {
        validators: [Validators.required],
        // asyncValidators: [checkAccountExist(this.apiService, this.userDetails, 'phone_number')],
        // updateOn: 'blur'
      }]
    });

    if(!!this.userDetails) {
      this.infoForm.patchValue({
        ...this.userDetails,
        'phone_number' : this.phonePipe.transform(this.userDetails['phone_number'], 'US')
      })
    }

    this.passwordForm = this.formBuilder.group({
      'currentPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      'password': ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      'confirmNewPassword': ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    },{validator: matchingPasswords('password', 'confirmNewPassword')});
  }
  
  // checkPasswordExist(control: AbstractControl): Promise<any | null> | Observable<any | null> {
  //   return this.apiService.checkCustomerPassword({'password': control.value}).pipe(map(data => {
  //     this.passwordForm.get('password').disable();
  //     this.passwordForm.get('confirmNewPassword').disable();
  //     if(data['response']['status'] === 2) {
  //       return {required: true};
  //     }else if(data['response']['status'] === 5) {
  //       return {exist: true};
  //     }else {
  //       this.passwordForm.get('password').enable();
  //       this.passwordForm.get('confirmNewPassword').enable();
  //       return null;
  //     }
  //   }, err =>  console.log(err)))
  // };

  public onInfoFormSubmit(values:Object):void {
    if (this.infoForm.valid) {
      this.saveButtonOptions.active = true;
      this.infoForm.value.phone_number = this.infoForm.value.phone_number.replace(/[^0-9]+/g, '');
      this.infoForm.value.email_id = this.infoForm.value.email_id.toLowerCase();
      let params = {
        website_check: "local",
        details_type: "account_info",
        ...this.infoForm.value
      }
      this.apiService.updateCustomerDetails(params).subscribe(res => {
        this.saveButtonOptions.active = false;
        if(res['response'].status === 0) {
          this.notification.error(res['response'].message, 5000);
        }else if(res['response'].status === 1) {
          this.userDetails = {...this.userDetails, ...this.infoForm.value};
          this.notification.success(res['response'].message, 5000);
          this.subscription.subjectNext({getUser: true});
        }else if(res['response'].status === 2 || res['response'].status === 3) {
          displayErrorMessage({
            notification: this.notification, 
            response: res['response'], 
            formControl: this.infoForm.controls
          });
        }else if(res['response'].status === 6 || res['response'].status === 4) {
          this.notification.error(res['response'].message, 5000);
        }
      }, err => {
        this.saveButtonOptions.active = false;
        console.log(err)
      });
    }
  }

  public onPasswordFormSubmit(resetPasswordChangeForm: FormGroupDirective):void {
    if (this.passwordForm.valid) {
      let currentPassword = this.passwordForm.value.currentPassword;
      this.changeButtonOptions.active = true;
      this.apiService.checkCustomerPassword({'password': currentPassword}).subscribe(data => {
        this.changeButtonOptions.active = false;
        if(data['response']['status'] === 2) {
          this.passwordForm.get('currentPassword').setErrors({required: true});
        }else if(data['response']['status'] === 5) {
          this.passwordForm.get('currentPassword').setErrors({exist: true});
        }else {
          let params = {
            website_check: "global",
            details_type: "account_info",
            password: this.passwordForm.get('password').value
          }
          this.apiService.updateCustomerDetails(params).subscribe(res => {
            if(res['response'].status === 0) {
              this.notification.error(res['response'].message, 5000);
            }else if(res['response'].status === 1) {
              resetPasswordChangeForm.resetForm();
              this.passwordForm.reset();
              this.notification.success(res['response'].message, 5000);
            }else if(res['response'].status === 2 || res['response'].status === 3) {
              displayErrorMessage({
                notification: this.notification, 
                response: res['response'], 
                formControl: this.passwordForm.controls
              });
            }else if(res['response'].status === 6) {
              this.notification.error(res['response'].message, 5000);
            }
          }, err => {
            this.changeButtonOptions.active = false;
            console.log(err)
          })
        }
      }, err => {
        console.log(err)
      });
    }
  }

}
